module.exports = __webpack_public_path__ + "img/troy_ill_be_back.ed9bdfc9.png";